export default __webpack_public_path__ + "static/media/jj.93285ce2.png";